import React from 'react';

import { Text, ThemeProvider } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { MIN_SIGNERS } from '../../constants';
import { useRecentSignersConnection } from '../../hooks/useRecentSignersConnection';
import { AccessibleDescription } from '../AccessibleDescription';
import { ActivityPill, ActivityScroller } from '../ActivityScroller';

export const RecentSignersViewportSmall: React.FC = () => {
	const recentSigners = useRecentSignersConnection();

	if (recentSigners.length < MIN_SIGNERS) {
		return null;
	}
	return (
		<ThemeProvider>
			<div
				/// / This makes the element overlap the padding from the MainContainer so that the list appears to scroll
				// off the edges of the device (viewport).
				className="relative mx-[-16px] mb-6 mt-8 flex flex-col gap-4"
				data-testid="recent-signers-mobile"
			>
				<Text fontWeight="bold" size="small" className="ml-4" variant="body">
					<Translate value="corgi.petition_gamma.recent_signers.title" />
				</Text>

				<ActivityScroller aria-hidden>
					{recentSigners.map((signer) => (
						<ActivityPill
							key={signer.id}
							title={signer.displayName}
							time={signer.createdAtRelativeLocalized}
							className="ml-4 h-[48px] scroll-ml-4 items-center"
						/>
					))}
				</ActivityScroller>

				<AccessibleDescription />
				<div
					className="pointer-events-none absolute top-0 h-full w-full"
					// eslint-disable-next-line react/forbid-dom-props
					style={{ background: 'linear-gradient(to right, transparent 80%, white)' }}
				/>
			</div>
		</ThemeProvider>
	);
};
